// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.register_page_header_block[data-v-4523026a] {\n    background-image: url('/images/providers_head.svg');\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.head_register-list[data-v-4523026a] {\n    color: var(--halfWhite-color);\n}\n", ""]);
// Exports
module.exports = exports;
